//Serviços
// import { Axios } from "../../service/serviceBasic";
import { AxiosCadastro } from "../../service/serviceBasic";
import { converterObjResumoForObjAction } from "../../helper/converter";
import { setMessageConclusaoAction } from "../conclusao/actions";

//Tipos
import {
  SET_RESUMO_UPLOAD,
  LOADING_RESUMO_UPLOAD,
  ERROR_RESUMO_UPLOAD,
  HANDLE_CHANGE_CHECK_BOX1,
  HANDLE_CHANGE_CHECK_BOX2
} from "./types";

const loadingObjResumoAction = (flag) => ({
  type: LOADING_RESUMO_UPLOAD,
  payload: flag,
});
const postObjResumoAction = (data) => (dispatch, getState) => {
  let {
    tipoCadastroReducer,
    dadosIniciaisPFReducer,
    dadosIniciaisPJReducer,
  } = getState();
  let email;

  switch (tipoCadastroReducer.tipoPessoaValue) {
    case "PessoaFisica":
      email = dadosIniciaisPFReducer.formPF.dadosIniciais_email;
      break;
    case "PessoaJuridica":
      email = dadosIniciaisPJReducer.formPJ.dadosIniciais_emailContato;
      break;
    default:
  }

  dispatch({ type: SET_RESUMO_UPLOAD, payload: data });

  dispatch(
    setMessageConclusaoAction({
      icon: "fa-check-circle-o",
      title: "Cadastro concluído com sucesso!",
      email: email,
      discription:
        "Falta pouco para abrir a sua Conta na B&T Câmbio! Já recebemos a sua solicitação. Seus documentos estão em análise e agora é só aguardar. Seu cadastro foi salvo para análise e enviamos um email para confirmação ao seguinte endereço:",
      isError: false,
    })
  );
};

const postErrorObjResumo = (message) => ({
  type: ERROR_RESUMO_UPLOAD,
  payload: message,
});

export const postObjCadastroResumoAction = () => (dispatch, getState) => {
  let {
    tipoCadastroReducer,
    dadosIniciaisPFReducer,
    dadosIniciaisPJReducer,
    enderecoReducer,
    dadosComplementaresReducer,
    declaracaoEspecificaReducer,
    maisDetalhesReducer,
    documentosAnexosReducer,
    associadoPJReducer,
    dadosBancarioReducer,
    navegationStepsReducer,
    resumoReducer,
    ddiReducer
  } = getState();

  let objResult = converterObjResumoForObjAction({
    tipoCadastroReducer,
    dadosIniciaisPFReducer,
    dadosIniciaisPJReducer,
    enderecoReducer,
    dadosComplementaresReducer,
    declaracaoEspecificaReducer,
    maisDetalhesReducer,
    documentosAnexosReducer,
    associadoPJReducer,
    navegationStepsReducer,
    dadosBancarioReducer,
    resumoReducer,
    ddiReducer
  });

  dispatch(loadingObjResumoAction(true));
  return AxiosCadastro.post("v1/basico/pessoa/cadastroWeb", objResult)
    .then((response) => {
      dispatch(postObjResumoAction(response.data));
    })
    .catch((error) => {
      dispatch(postErrorObjResumo(error.message));
      dispatch(
        setMessageConclusaoAction({
          icon: "fa-close",
          title: "Não foi possível efetuar o seu cadastro!",
          error: error.response ? error.response.data.Message : error.message,
          discription: `Algo deu errado ao enviar seus dados para análise, é possível que alguma informação preenchida esteja inconsistente.`,
          isError: true,
        })
      );
      dispatch(loadingObjResumoAction(false));
    })
    .finally(() => {
      dispatch(loadingObjResumoAction(false));
    });
};

export const handleChangeCheckBox1 = (event) => (dispatch) => {
  dispatch({
    type: HANDLE_CHANGE_CHECK_BOX1,
    payload: event.value,
  });
};

export const handleChangeCheckBox2 = (event) => (dispatch) => {
  dispatch({
    type: HANDLE_CHANGE_CHECK_BOX2,
    payload: event.value,
  });
};
